module.exports = __webpack_public_path__ + "img/TTO.cc114b7a.svg";